import React from 'react';
import { Caption, Heading2, Heading3 } from '@qover/typography';
import { SecondaryLightLink } from '@qover/molecules';
import messages from './confirmationContent.messages';
import { Document, Documents, Container } from './confirmationContent.styles';

type Link = {
  'data-test': string;
  filename?: string;
  text?: React.ReactNode;
  url: string;
};

type Doc = {
  description?: React.ReactNode;
  link: Link;
  onDownload: () => void;
  title: React.ReactNode;
};

export type ConfirmationContentProps = {
  containerClassName?: string;
  documents: Doc[];
  policyholderEmail: string;
  thankYouForChoosing: React.ReactNode;
};

export function ConfirmationContent(props: ConfirmationContentProps) {
  return (
    <Container className={props.containerClassName}>
      <div>
        <Heading2>{messages.yourPolicyDocuments}</Heading2>
        <Heading3>{props.thankYouForChoosing}</Heading3>
        <p>
          <strong>{messages.pleaseFindYourPolicy}</strong>
        </p>
        <p>{messages.yourPolicySchedule(props.policyholderEmail)}</p>
        {messages.feelFreeToContactUs}
      </div>
      <Documents>
        {props.documents.map((document: Doc, idx) => (
          <Document key={idx}>
            <div>
              <Heading3 as="div">{document.title}</Heading3>
              {document.description && (
                <Caption className="font-italic">
                  {document.description}
                </Caption>
              )}
            </div>
            <SecondaryLightLink
              data-test={document.link['data-test']}
              download={document.link.filename}
              href={document.link.url}
              onClick={document.onDownload}
            >
              {messages.download}
            </SecondaryLightLink>
          </Document>
        ))}
      </Documents>
    </Container>
  );
}
